import React from 'react';

export default function SubscriptionUsageContinued() {
  // Data structure for easy dynamic implementation
  const pageData = {
    title: "Subscription Awareness & Usage (Cont.)",
    pageNumber: 29,
    boxes: [
      {
        id: 1,
        backgroundColor: "#aee772",
        heading: "Usage skews heavily toward a few key players",
        subheading: "Across 'currently using' and 'ever used,' the top brands are:",
        bulletPoints: [
          {
            text: "Chewy (Current: 18%; Ever Used: 37%)",
            isBold: true
          },
          {
            text: "Amazon (Current: 14%; Ever Used: 25%)",
            isBold: true
          },
          {
            text: "Bark Box (Current: 6%; Ever Used: 13%)",
            isBold: true
          },
          {
            text: "Petco/PetSmart (Current: 2%; Ever Used: 6%)",
            isBold: true
          }
        ],
        footerText: "This indicates clear leaders in converting awareness into actual trial."
      },
      {
        id: 2,
        backgroundColor: "#aee772",
        heading: "Emerging specialty brands show high awareness but low active usage",
        subheading: "Brands like Spot & Tango, We Feed Raw, Raised Right, Dogs Table show 96~98% awareness but lower active usage rates:",
        bulletPoints: [
          {
            text: "Strong top of funnel visibility",
            isBold: false
          },
          {
            text: "Limited conversion of that awareness into commitment",
            isBold: false
          },
          {
            text: "Opportunity to improve trial through offers",
            isBold: false
          }
        ],
        footerText: "This indicates clear leaders in converting awareness into actual trial."
      },
      {
        id: 3,
        backgroundColor: "#aee772",
        heading: "Pet influencer followers are more aware across nearly all services",
        subheading: "Across the board, influencer followers show:",
        bulletPoints: [
          {
            text: "Higher awareness",
            isBold: false
          },
          {
            text: "Higher past usage",
            isBold: false
          },
          {
            text: "Higher current subscriptions",
            isBold: false
          }
        ],
        footerText: "They act as a high-value micro-segment for subscription marketing.",
        highlightText: "high-value micro-segment"
      }
    ]
  };

  return (
   <div className="flex flex-col h-full items-center w-full">
      <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-4 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">{pageData.title}</h1>


      {/* Content Boxes Grid */}
      <div className="grid grid-cols-2 gap-2 mb-6">
        {/* First Box - Spans full width on left */}
        <div 
          className={`bg-[${pageData.boxes[0].backgroundColor}] border-2  p-2 rounded-xl`}
        >
          <h2 className="text-sm font-bold mb-3">
            {pageData.boxes[0].heading}
          </h2>
          <p className="text-sm mb-3">{pageData.boxes[0].subheading}</p>
          
          <ul className="space-y-2 mb-4">
            {pageData.boxes[0].bulletPoints.map((point, index) => (
              <li key={index} className="flex items-start text-sm">
                <span className="mr-2">•</span>
                <span className={point.isBold ? "font-bold" : ""}>
                  {point.text}
                </span>
              </li>
            ))}
          </ul>
          
          <p className="text-sm leading-relaxed">
            {pageData.boxes[0].footerText}
          </p>
        </div>

        {/* Right Column - Two Boxes Stacked */}
        <div className="space-y-2">
          {/* Second Box */}
          <div 
            className={`bg-[${pageData.boxes[1].backgroundColor}] border-2  p-2 rounded-xl`}
          >
            <h2 className="text-sm font-bold mb-2">
              {pageData.boxes[1].heading}
            </h2>
            <p className="text-sm mb-2">{pageData.boxes[1].subheading}</p>
            
            <ul className="space-y-1 mb-2">
              {pageData.boxes[1].bulletPoints.map((point, index) => (
                <li key={index} className="flex items-start text-sm">
                  <span className="mr-2">•</span>
                  <span className={point.isBold ? "font-bold" : ""}>
                    {point.text}
                  </span>
                </li>
              ))}
            </ul>
            
            <p className="text-sm leading-relaxed">
              {pageData.boxes[1].footerText}
            </p>
          </div>

          {/* Third Box */}
          <div 
            className={`bg-[${pageData.boxes[2].backgroundColor }] border-2 p-2 rounded-xl`}
          >
            <h2 className="text-sm font-bold mb-2">
              {pageData.boxes[2].heading}
            </h2>
            <p className="text-sm mb-2">{pageData.boxes[2].subheading}</p>
            
            <ul className="space-y-1 mb-2">
              {pageData.boxes[2].bulletPoints.map((point, index) => (
                <li key={index} className="flex items-start text-sm">
                  <span className="mr-2">•</span>
                  <span className={point.isBold ? "font-bold" : ""}>
                    {point.text}
                  </span>
                </li>
              ))}
            </ul>
            
            <p className="text-sm leading-relaxed">
              They act as a{' '}
              <span className="font-bold">{pageData.boxes[2].highlightText}</span>
              {' '}for subscription marketing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}